import { useToggle } from "../../../../../hooks/useToggle.js";
import { UserAnPCheck } from "../../../../shared/UserAnPCheck.js";
import { EditButton } from "../../../../../components/Buttons/index.js";
import { EventInfoFormBuilderForm } from "./components/FormBuilderForm.js";
import { EventInfoFormBuilderDisplay } from "./components/FormBuilderDisplay.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Events/shared/EventInteractive/EventInfoFormBuilder/index.tsx
function EventInfoFormBuilder({ allowEdit, event, eventType, refresh }) {
	const [isEditing, toggleIsEditing] = useToggle(false);
	if (isEditing) return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(EventInfoFormBuilderForm, {
		event,
		eventType,
		onCancel: toggleIsEditing,
		onComplete: () => {
			refresh?.();
			toggleIsEditing();
		}
	}) });
	return /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx(EventInfoFormBuilderDisplay, {
		event,
		eventType
	}), allowEdit && /* @__PURE__ */ jsx(UserAnPCheck, {
		check: (user) => user.anp.role.ops.permissions.createEvents && event.history?.createdBy === user.id || user.anp.role.ops.permissions.editEvents || event?.assignedUsers.find(({ userId }) => user.id === userId),
		children: /* @__PURE__ */ jsx("div", {
			className: "flex justify-end",
			children: /* @__PURE__ */ jsx(EditButton, { onClick: toggleIsEditing })
		})
	})] });
}
//#endregion
export { EventInfoFormBuilder };

//# sourceMappingURL=index.js.map